import { Tag } from 'antd';
import { getSeverityColor } from 'utils/color/helpers';
import styled, { useTheme } from 'styled-components';

const SeverityTag = ({ value, maxValue, ...props }) => {
  const theme = useTheme();

  return (
    <Tag data-testid="severity-tag" color={getSeverityColor(theme, value, maxValue)} {...props}>
      {value}
    </Tag>
  );
};

export default styled(SeverityTag)`
  &.ant-tag {
    margin-right: 0;
  }
`;
